"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingPeriodGap = void 0;
const react_1 = __importDefault(require("react"));
const Section_1 = require("../section/Section");
const InlineMessage_1 = require("../inline-message/InlineMessage");
const Button_1 = require("../button/Button");
const Spacer_1 = require("../spacer/Spacer");
const PricingPeriodGap = ({ start, end, onAddClicked }) => {
    return (react_1.default.createElement("div", { "data-testId": `pricing-period-gap-${start}-${end}` },
        react_1.default.createElement(Section_1.Section, { heading: "Pricing gap" },
            react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
            react_1.default.createElement(InlineMessage_1.InlineError, { text: `${start.toString()} - ${end.toString()}` }),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Button_1.Button, { onClick: () => onAddClicked(start, end) }, "Add pricing period"))));
};
exports.PricingPeriodGap = PricingPeriodGap;
//# sourceMappingURL=PricingPeriodGap.js.map